<template>
  <v-card flat class="ma-0 pl-5 pr-5 grey lighten-5 round-0">
    <a
      ref="google_playstore_link"
      disabled="true"
      target="_blank"
      href="https://play.google.com/store/apps/details?id=com.botswanaservices.v2.botswanaservices"
    ></a>

    <v-list-item
      two-line
      class="pointer pa-0 mb-0"
      @click="on_click_self_advert"
    >
      <v-list-item-content class="">
        <v-list-item-title class="body-1 text-left">
          Join
          <b
           v-if="number_of_businesses > 0"
            >
            <ICountUp
              :delay="delay"
              :endVal="number_of_businesses"
              :options="options"
              @ready="on_ready"
            />
          </b>
          Businesses On
        </v-list-item-title>
        <v-list-item-subtitle class="body-2 text-left"
          >Bostwana's Premium Business Directory
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="pa-0 pl-2 mt-0" @click="on_click_self_advert">
      <v-row align="center" class="pointer" no-gutters>
        <v-col class="">
          <v-img
            contain
            src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600832140/botswana%20services/website%20assets/ad_android_rzucnn.png"
            alt="android app"
          ></v-img>
          <small>Version 2.0.0</small>
          <small>&nbsp;&nbsp;- Promotions, Catalogues & ads</small>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
  </v-card>
</template>

<script>
import ServerClient from "./../lib/ServerClient";
import Utils from "./../lib/Utils";
import ICountUp from "vue-countup-v2";
export default {
  name: "SelfPromoAdd",
  components: {
    ICountUp,
  },
  props: {
    page: {
      type: String,
      default: "",
    },
    section: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      number_of_businesses: 0,
      delay: 5000,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: "",
      },
    };
  },
  methods: {
    on_ready: function (instance, CountUp) {
      const that = this;
      instance.update(that.number_of_businesses + 1);
    },
    on_click_self_advert() {
      var user = ServerClient.Login.get_logged_in_user();
      //record this clicking before redirecting the user to the download link
      ServerClient.Promotions.record_clicked_self_promotion(
        {
          advert_name: "download_android_app",
          user_id: user == null ? 0 : user.id,
          page: this.page,
          section: this.section,
        },
        (res) => {
          //redirect user to andoid download page on new tab
          this.$refs["google_playstore_link"].click();
        },
        (errors) => {
          console.log(
            "SelfPromoAdd: Errors clicking download app link ",
            errors
          );
        }
      );
    },
  },
  mounted() {
    ServerClient.Businesses.get_number_of_businesses(
      {},
      (res) => {
        this.number_of_businesses = parseInt(res); //Utils.comma(res);
      },
      (errors) => {
        console.log(
          "SelfPromoAdd: Errors loading number of businesses ",
          errors
        );
      }
    );
  },
};
</script>